<template>
  <mf-loading :loading="loadingInfos">
    <v-row class="pt-2">
      <v-col v-for="(info, index) in cardsInfo" :key="index" cols="4">
        <v-card class="decomposition elevation-0">
          <v-skeleton-loader v-if="loadingInfos" class="pl-2" type="card-heading" />
          <v-card-title v-else>
            <h2 class="mb-0 decomposition_title">{{ info.title }}</h2>
            <v-spacer />
            <mf-tooltip right max-width="200">
              <template #activator="{ on }">
                <mf-icon size="18" class="mt-n4" color="cinza-0">info</mf-icon>
              </template>
              <span>{{ info.tooltip }}</span>
            </mf-tooltip>
          </v-card-title>
          <v-skeleton-loader v-if="loadingInfos" class="px-2" type="list-item-avatar, card-heading" />
          <v-card-text v-else>
            <v-row justify="center" align="center">
              <v-col cols="2">
                <div class="arrow-box d-flex justify-center align-center" :class="`arrow-box_${info.arrow}`">
                  <mf-icon size="30" color="branco" :icon="info.arrowIcon" />
                </div>
              </v-col>
              <v-col cols="10" class="percentual-text" :class="`percentual-text_${info.arrow}`">
                {{ info.period | localeString(2) }}
                <span v-if="typeof info.period === 'number'">%</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="mb-1 decomposition_detail-title light-grey">Período atual</p>
                <p class="decomposition_detail-info dark-grey"><span v-if="info.currency">R$</span> {{ info.current | localeString(info.decimal) }}</p>
              </v-col>
              <v-col cols="6">
                <p class="mb-1 decomposition_detail-title light-grey">Período referência</p>
                <p class="decomposition_detail-info dark-grey"><span v-if="info.currency">R$</span> {{ info.referency | localeString(info.decimal) }}</p>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-if="info.extra.length > 0" class="decomposition_extra">
            <v-row>
              <v-col v-for="(extra, indexExtra) in info.extra" :key="indexExtra" cols="6" class="py-0 px-1">
                <v-card height="407">
                  <v-skeleton-loader v-if="loadingInfos" class="px-2 pt-3" type="text" />
                  <v-card-title v-else>
                    <h2 class="mb-0 mt-n5 decomposition_extra-title light-grey">{{ extra.title }}</h2>
                    <v-spacer />
                    <mf-tooltip right max-width="200">
                      <template #activator="{ on }">
                        <mf-icon size="18" class="mt-n4" color="cinza-0">info</mf-icon>
                      </template>
                      <span>{{ extra.tooltip }}</span>
                    </mf-tooltip>
                  </v-card-title>
                  <v-skeleton-loader v-if="loadingInfos" class="px-2" type="card-heading, list-item-avatar, card-heading, card-heading, list-item-three-line" />
                  <v-card-text v-else>
                    <h3 class="decomposition_extra-subtitle">{{ extra.subtitle }}</h3>
                    <v-row justify="center" align="center">
                      <v-col cols="4">
                        <div class="arrow-box d-flex justify-center align-center" :class="`arrow-box_${extra.arrow}`">
                          <mf-icon size="30" color="white" :icon="extra.arrowIcon" />
                        </div>
                      </v-col>
                      <v-col cols="8">
                        <p class="mb-0 percentual-text percentual-text_minor" :class="`percentual-text_${extra.arrow}`">
                          {{ extra.period | localeString(2) }}
                          <span v-if="typeof info.period === 'number'">%</span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <p class="mb-1 decomposition_extra-title text-bold dark-grey">Período atual</p>
                        <p class="mb-0 decomposition_extra-info text-bold dark-grey">
                          <span v-if="extra.currency">R$</span>
                          {{ extra.current | localeString(extra.decimal) }}
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <p class="mb-1 decomposition_extra-title light-grey">Período referência</p>
                        <p class="mb-0 decomposition_extra-info light-grey">
                          <span v-if="extra.currency">R$</span>
                          {{ extra.referency | localeString(extra.decimal) }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-skeleton-loader v-if="loadingInfos" class="px-2 pt-3" type="button" />
                  <v-card-actions v-else class="action-position">
                    <mf-button
                      :color="extra.detailOpen ? 'marca-0-l10' : 'cinza-l30'"
                      :disabled="extra.detailButtonDisabled"
                      label="Ver detalhes"
                      block
                      icon-position="right"
                      :icon="extra.detailOpen ? 'expand_less' : 'expand_more'"
                      @click="openDetails(extra, index, indexExtra)"
                    />
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-card>
        <v-card v-if="!info.extra.length" class="mt-1 elevation-0" height="418">
          <div class="background-card d-flex justify-center align-center">
            <img height="161px" width="219px" :src="require('@/assets/empty_card.png')" />
          </div>
          <v-card-text>
            <p class="ma-0 dark-grey">
              Confira ao lado <span class="text-link">quatro indicadores</span> que impactam no Ticket Médio, Número de Cupons e Faturamento do seu negócio.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </mf-loading>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'DecompositionCards',
  props: {
    loadingInfos: {
      type: Boolean,
      required: true,
    },
    referencyData: {
      type: Object,
      required: true,
    },
    currentData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    icons: {
      up: 'arrow_upward',
      down: 'arrow_downward',
      neutral: 'remove',
    },
    cardsInfo: [
      {
        title: 'Faturamento',
        arrow: 'none',
        tooltip: 'É a multiplicação do seu ticket médio pelo número total de cupons.',
        period: '-',
        current: '-',
        referency: '-',
        arrowIcon: '',
        extra: [],
      },
      {
        title: 'Ticket médio',
        arrow: 'none',
        tooltip: 'É feita a divisão do seu faturamento pelo número total de cupons.',
        period: '-',
        current: '-',
        referency: '-',
        arrowIcon: '',
        extra: [
          {
            title: 'Ticket Médio',
            subtitle: 'Média de itens na cesta',
            arrow: 'none',
            tooltip: 'É a soma de todos os itens comprados, dividido pela quantidade de cupons.',
            period: '-',
            current: '-',
            referency: '-',
            arrowIcon: '',
            detailOpen: false,
            currency: false,
            detailButtonDisabled: true,
            indicator: 'AVERAGE_ITEMS_IN_BASKET',
          },
          {
            title: 'Ticket Médio',
            subtitle: 'Valor médio dos produtos',
            arrow: 'none',
            tooltip: 'O faturamento é dividido pelo total de produtos.',
            period: '-',
            current: '-',
            referency: '-',
            arrowIcon: '',
            detailOpen: false,
            currency: false,
            detailButtonDisabled: true,
            indicator: 'AVERAGE_PRODUCT_VALUE',
          },
        ],
      },
      {
        title: 'Número de cupons',
        arrow: 'none',
        tooltip: 'É o total de cupons do seu estabelecimento nos períodos analisados.',
        period: '-',
        current: '-',
        referency: '-',
        arrowIcon: '',
        extra: [
          {
            title: 'Número de cupons',
            subtitle: 'Estimativa de clientes únicos',
            arrow: 'none',
            tooltip: 'É o número de Clientes Únicos pertencentes ao Clube que realizaram ao menos uma compra no seu estabelecimento.',
            period: '-',
            current: '-',
            referency: '-',
            arrowIcon: '',
            detailOpen: false,
            currency: false,
            detailButtonDisabled: true,
            indicator: 'UNIQUE_CUSTOMERS',
          },
          {
            title: 'Número de cupons',
            subtitle: 'Média de compras por cliente',
            tooltip: 'É a divisão do total de compras no clube pelo total de clientes que compraram no seu negócio.',
            arrow: 'none',
            period: '-',
            current: '-',
            referency: '-',
            arrowIcon: '',
            detailOpen: false,
            currency: false,
            detailButtonDisabled: true,
            indicator: 'AVERAGE_CUSTOMER_SPEND',
          },
        ],
      },
    ],
  }),
  watch: {
    referencyData: {
      handler() {
        if (!isEmpty(this.referencyData) && !isEmpty(this.currentData)) this.setCardsInfo()
      },
      immediate: true,
    },
    currentData: {
      handler() {
        if (!isEmpty(this.currentData) && !isEmpty(this.referencyData)) this.setCardsInfo()
      },
      immediate: true,
    },
  },
  methods: {
    checkValue(value) {
      return value && value.length ? value[0].value : 0
    },
    openDetails(extra, infoPosition, extraInfoPosition) {
      const { detailOpen } = extra

      this.cardsInfo.forEach((info) => {
        if (info.extra.length) {
          info.extra.forEach((extraInfo) => {
            extraInfo.detailOpen = false
          })
        }
      })

      this.cardsInfo[infoPosition].extra[extraInfoPosition].detailOpen = !detailOpen

      const formatAverageProductValue = { averageProducts: this.checkValue(this.currentData.average_product_value) }
      const formatAverageItems = { averageItems: this.checkValue(this.currentData.average_items_in_basket) }
      const formatAverageCoupons = { averageCoupons: this.checkValue(this.currentData.average_customer_coupons) }
      const formatInfos = Object.assign(extra, formatAverageProductValue, formatAverageItems, formatAverageCoupons)
      this.$emit('open-details', formatInfos)
    },
    getPercentualPeriod(currentValue, referencyValue, returnPercentual = false) {
      const currentValueFormat = currentValue && currentValue.length ? currentValue[0].value : 0
      const referencyValueFormat = referencyValue && referencyValue.length ? referencyValue[0].value : 0
      const percentual = (currentValueFormat * 100) / referencyValueFormat
      let result = 0
      if (percentual >= 100) {
        result = percentual - 100
      } else {
        result = 100 - percentual
      }

      return returnPercentual ? percentual : result
    },
    getArrowPosition(currentValue, referencyValue) {
      const result = this.getPercentualPeriod(currentValue, referencyValue, true)

      return result === 100 ? 'neutral' : result >= 100 ? 'up' : 'down'
    },
    setCardsInfo() {
      this.cardsInfo = [
        {
          title: 'Faturamento',
          tooltip: 'É a multiplicação do seu ticket médio pelo número total de cupons.',
          decimal: 2,
          arrow: this.getArrowPosition(this.currentData.revenue, this.referencyData.revenue),
          period: this.getPercentualPeriod(this.currentData.revenue, this.referencyData.revenue),
          current: this.checkValue(this.currentData.revenue),
          referency: this.checkValue(this.referencyData.revenue),
          arrowIcon: this.icons[this.getArrowPosition(this.currentData.revenue, this.referencyData.revenue)],
          currency: true,
          extra: [],
        },
        {
          title: 'Ticket médio',
          tooltip: 'É feita a divisão do seu faturamento pelo número total de cupons.',
          decimal: 2,
          arrow: this.getArrowPosition(this.currentData.average_ticket, this.referencyData.average_ticket),
          period: this.getPercentualPeriod(this.currentData.average_ticket, this.referencyData.average_ticket),
          current: this.checkValue(this.currentData.average_ticket),
          referency: this.checkValue(this.referencyData.average_ticket),
          arrowIcon: this.icons[this.getArrowPosition(this.currentData.average_ticket, this.referencyData.average_ticket)],
          currency: true,
          extra: [
            {
              title: 'Ticket Médio',
              subtitle: 'Média de itens na cesta',
              tooltip: 'É a soma de todos os itens comprados, dividido pela quantidade de cupons.',
              arrow: this.getArrowPosition(this.currentData.average_items_in_basket, this.referencyData.average_items_in_basket),
              period: this.getPercentualPeriod(this.currentData.average_items_in_basket, this.referencyData.average_items_in_basket),
              current: this.checkValue(this.currentData.average_items_in_basket),
              referency: this.checkValue(this.referencyData.average_items_in_basket),
              arrowIcon: this.icons[this.getArrowPosition(this.currentData.average_items_in_basket, this.referencyData.average_items_in_basket)],
              clubValue: this.checkValue(this.currentData.loyalty_average_items_in_basket),
              noClubValue: this.checkValue(this.currentData.non_loyalty_average_items_in_basket),
              detailOpen: false,
              currency: false,
              detailButtonDisabled: false,
              decimal: 2,
              indicator: 'AVERAGE_ITEMS_IN_BASKET',
            },
            {
              title: 'Ticket Médio',
              subtitle: 'Valor médio dos produtos',
              tooltip: 'O faturamento é dividido pelo total de produtos.',
              arrow: this.getArrowPosition(this.currentData.average_product_value, this.referencyData.average_product_value),
              period: this.getPercentualPeriod(this.currentData.average_product_value, this.referencyData.average_product_value),
              current: this.checkValue(this.currentData.average_product_value),
              referency: this.checkValue(this.referencyData.average_product_value),
              arrowIcon: this.icons[this.getArrowPosition(this.currentData.average_product_value, this.referencyData.average_product_value)],
              clubValue: this.checkValue(this.currentData.loyalty_average_product_value),
              noClubValue: this.checkValue(this.currentData.non_loyalty_average_product_value),
              detailOpen: false,
              currency: true,
              detailButtonDisabled: false,
              decimal: 2,
              indicator: 'AVERAGE_PRODUCT_VALUE',
            },
          ],
        },
        {
          title: 'Número de cupons',
          tooltip: 'É o total de cupons do seu estabelecimento nos períodos analisados.',
          decimal: 0,
          arrow: this.getArrowPosition(this.currentData.total_coupons, this.referencyData.total_coupons),
          period: this.getPercentualPeriod(this.currentData.total_coupons, this.referencyData.total_coupons),
          current: this.checkValue(this.currentData.total_coupons),
          referency: this.checkValue(this.referencyData.total_coupons),
          arrowIcon: this.icons[this.getArrowPosition(this.currentData.total_coupons, this.referencyData.total_coupons)],
          extra: [
            {
              title: 'Número de cupons',
              subtitle: 'Estimativa de clientes únicos',
              noClubCardTitle: 'Estimativa de clientes únicos',
              noClubCardSubtitle: 'Calculada a partir do padrão de compra de clientes do clube',
              tooltip:
                'Estimativa de clientes que fizeram compras nesse período, com base na quantidade de cupons realizada e média de cupons que cada cliente gera.',
              period: this.getPercentualPeriod(this.currentData.estimated_total_number_of_customers, this.referencyData.estimated_total_number_of_customers),
              arrow: this.getArrowPosition(this.currentData.estimated_total_number_of_customers, this.referencyData.estimated_total_number_of_customers),
              current: this.checkValue(this.currentData.estimated_total_number_of_customers),
              referency: this.checkValue(this.referencyData.estimated_total_number_of_customers),
              arrowIcon:
                this.icons[this.getArrowPosition(this.currentData.estimated_total_number_of_customers, this.referencyData.estimated_total_number_of_customers)],
              clubValue: this.checkValue(this.currentData.unique_customers),
              noClubValue: this.checkValue(this.currentData.estimated_total_number_of_customers),
              detailOpen: false,
              currency: false,
              detailButtonDisabled: false,
              decimal: 0,
              indicator: 'UNIQUE_CUSTOMERS',
            },
            {
              title: 'Número de cupons',
              subtitle: 'Média de compras por cliente',
              tooltip: 'É a divisão do total de compras no clube pelo total de clientes que compraram no seu negócio.',
              arrow: this.getArrowPosition(this.currentData.average_customer_coupons, this.referencyData.average_customer_coupons),
              period: this.getPercentualPeriod(this.currentData.average_customer_coupons, this.referencyData.average_customer_coupons),
              current: this.checkValue(this.currentData.average_customer_coupons),
              referency: this.checkValue(this.referencyData.average_customer_coupons),
              arrowIcon: this.icons[this.getArrowPosition(this.currentData.average_customer_coupons, this.referencyData.average_customer_coupons)],
              detailOpen: false,
              currency: false,
              detailButtonDisabled: false,
              decimal: 2,
              indicator: 'AVERAGE_CUSTOMER_SPEND',
            },
          ],
        },
      ]
    },
  },
}
</script>

<style lang="scss">
$neutral-color: #e0c110;
$text-bold: 700;

.decomposition {
  word-wrap: break-word;
  &_title {
    font-size: 26px;
    font-weight: $text-bold;
  }
  &_detail-title {
    font-size: 16px;
  }
  &_detail-info {
    font-size: 22px;
    font-weight: $text-bold;
  }
  &_extra {
    height: 420px;
    background-color: $cinza-l60;
    padding: 6px 18px;
    &-title {
      font-size: 14px;
    }
    &-subtitle {
      font-weight: 500;
      font-size: 18px;
      color: $cinza-d20;
    }
    &-info {
      font-size: 26px;
    }
  }
  .arrow-box {
    height: 48px;
    width: 48px;
    border-radius: 5px;
    margin: 0;
    &_up {
      background-color: $verde-0;
    }
    &_down {
      background-color: $vermelho-0;
    }
    &_neutral {
      background-color: $neutral-color;
    }
    &_none {
      background-color: $cinza-0;
    }
  }
  .percentual-text {
    font-weight: $text-bold;
    font-size: 36px;
    word-wrap: break-word;
    &_up {
      color: $verde-0;
    }
    &_down {
      color: $vermelho-0;
    }
    &_none {
      color: $cinza-0;
    }
  }
  .percentual-text_minor {
    font-weight: 400;
    font-size: 24px;
    word-wrap: break-word;
  }
}
.text-bold {
  font-weight: $text-bold;
}
.dark-grey {
  color: $cinza-d10;
}
.light-grey {
  color: $cinza-0;
}
.background-card {
  width: 100%;
  height: 250px;
  background-color: $ilustracao-solid-4;
}
.align-actions {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.text-link {
  color: $ilustracao-solid-1 !important;
}
.text-nostyle {
  text-transform: none;
}
.action-position {
  display: block;
  position: absolute;
  width: 100% !important;
  bottom: 0;
  .v-badge {
    width: 100% !important;
  }
}
</style>
